import { render, staticRenderFns } from "./VoteButtons.vue?vue&type=template&id=7f6ec5e0&"
import script from "./VoteButtons.vue?vue&type=script&lang=ts&"
export * from "./VoteButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports